<template>
    <div class="app-container" :class="modeClasses">
        <div class="base-layout">
            <main-navigation :showNav="showMainNav" :showNavLinks="showMenuNavLinks" />

            <slot class="base-content" />
        </div>

        <app-footer />
    </div>
</template>


<script>
    import MainNavigation from '../parts/MainNavigation.vue'
    import AppFooter from '../parts/AppFooter.vue'


    export default {
        components: {MainNavigation, AppFooter},

        props: {
            showMainNav:        { type: Boolean, default: true },
            showMenuNavLinks:   { type: Boolean, default: true },
        },

        computed: {
            modeClasses() {
                const routeName = this.routeName
                let classes = {
                    'exercise-mode':   this.isExerciseMode,
                    'test-mode':        this.isTestMode,
                    'test-active':      this.isTestActive
                }

                if(routeName && !this.isExerciseMode && !this.isTestMode)
                    classes[routeName] = true

                return classes
            }
        },
    }
</script>


<style lang="scss">
    @use '~sass/variables' as *;

    .flexing-out {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .app-container {
        margin: 0;
        padding: 0;

        .base-layout {
            @extend .flexing-out;
            flex-direction: column;
            justify-content: flex-start;

            width: 100%;
            margin: 0;
            padding: 0;

            .base-content { flex: 1; }
        }
    }
</style>